import React from 'react';
import ScoreBadge from './ScoreBadge';
import HoverCard from './HoverCard';
import ScoreBreakdown from './ScoreBreakdown';
import { isRedZone } from '../lib/scoring';

/**
 * A CScore badge that explains itself on hover and flags the red zone.
 *
 * Every list that shows a score renders this rather than a bare ScoreBadge, so
 * the hover breakdown and the watch list flag can never drift apart between
 * the dashboard, the clinic page and the clinician list.
 *
 * `breakdown` may be null (no scored months, or an older record) — HoverCard
 * falls back to rendering the badge alone.
 */
export default function ScoreCell({ score, breakdown, weights, threshold, size = 'md', title }) {
  const flagged = isRedZone(score, threshold);

  return (
    <HoverCard
      panel={breakdown ? (
        <ScoreBreakdown breakdown={breakdown} score={score} weights={weights} title={title} />
      ) : null}
    >
      <ScoreBadge score={score} size={size} flagged={flagged} />
    </HoverCard>
  );
}
